<template>
    <div>

<!--hero section start-->

<section class="banner banner-5 fullscreen-banner o-hidden p-0 parallaxie" data-bg-img="images/bg/03.jpg" data-overlay="6">
  <div class="align-center pt-0">
    <div class="container">
      <div class="row justify-content-center text-center">
        <div class="col-lg-8">
          <h4 class="text-white">Created For <span class="typer text-theme" data-words="Agency,Marketing,Portfolio,Creative" ></span>
        <span style="font-size:1.2em;vertical-align:middle;" class="cursor" data-cursorDisplay="|" data-owner="some-id"></span></h4>
          <h1 class="text-white font-w-7 mb-4">Designed And Launch faster with Agencio</h1>
          <a class="btn btn-theme" href="#"><span>Explore Now <i class="fas fa-plus-square"></i></span></a>

        </div>
      </div>
    </div>
  </div>
  <div class="lines">
  <div class="line"></div>
  <div class="line"></div>
  <div class="line"></div>
</div>
  <img src="images/bg/07.svg" alt="" class="round-shape">
</section>

<!--hero section end-->


<!--body content start-->

<div id="main-page" class="page-content">

<!--feature start-->

<section class="p-0 custom-mt-10">
  <div class="container">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div class="featured-item white-bg">
          <div class="featured-icon"> <i class="flaticon-idea"></i>
          </div>
          <div class="featured-title">
            <h5 class="mb-0">Design</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 mt-5 mt-sm-0">
        <div class="featured-item theme-bg">
          <div class="featured-icon"> <i class="flaticon-domain"></i>
          </div>
          <div class="featured-title">
            <h5 class="mb-0">Development</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 mt-5 mt-lg-0">
        <div class="featured-item white-bg">
          <div class="featured-icon"> <i class="flaticon-analytics"></i>
          </div>
          <div class="featured-title">
            <h5 class="mb-0">Analytics</h5>
          </div>
        </div>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-6 mt-5 mt-lg-0">
        <div class="featured-item theme-bg">
          <div class="featured-icon"> <i class="flaticon-optimization"></i>
          </div>
          <div class="featured-title">
            <h5 class="mb-0">Optimization</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--feature end-->


<!--about start-->

<section>
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-12">
        <img class="img-fluid w-75 box-shadow" src="images/about/01.jpg" alt="">
        <div class="img-bg">
          <svg class="morph-shape" viewBox="0 0 500 500">
            <defs>
              <linearGradient id="main-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="10%" style="stop-color:#0083ff;"></stop>
                <stop offset="100%" style="stop-color:#00f2aa;"></stop>
              </linearGradient>
            </defs>
            <path id="object" class="js-items-shape-path" fill="url(#main-gradient)" d="M418.1 159.8 C460.9 222.9 497 321.5 452.4 383.4 417.2 432.4 371.2 405.6 271.3 420.3 137.19 440 90.45 500.6 42.16 442.8 -9.57 381 86.33 289.1 117.7 215.5 144.3 153.4 145.69 54.21 212.7 36.25 290.3 15.36 373.9 94.6 418.1 159.8 " data-original="M 418.1,159.8 C 460.9,222.9 497,321.5 452.4,383.4 417.2,432.4 371.2,405.6 271.3,420.3 137.2,440 90.45,500.6 42.16,442.8 -9.572,381 86.33,289.1 117.7,215.5 144.3,153.4 145.7,54.21 212.7,36.25 290.3,15.36 373.9,94.6 418.1,159.8 Z"></path>
          </svg>
        </div>
      </div>
      <div class="col-lg-6 col-12 mt-5 mt-lg-0">
        <div class="section-title">
          <h2 class="title">We are specialize for <span>Creative Brands</span></h2>
          <p class="lead">Agencio discovering the source behind the ubiquitous filler text In seeing a sample of lorem ipsum, his interest was piqued by consectetur Agencio discovering</p>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <div class="ht-progress-bar">
          <h6>Business</h6>
          <div class="progress" data-value="75">
            <div class="progress-bar">
              <div class="progress-parcent"><span>75</span>%</div>
            </div>
          </div>
        </div>
          </div>
          <div class="col-sm-6 mt-5 mt-sm-0">
            <div class="ht-progress-bar">
          <h6>Marketing</h6>
          <div class="progress" data-value="70">
            <div class="progress-bar">
              <div class="progress-parcent"><span>70</span>%</div>
            </div>
          </div>
        </div>
          </div>
          <div class="col-sm-6 mt-5">
            <div class="ht-progress-bar">
          <h6>Design</h6>
          <div class="progress" data-value="90">
            <div class="progress-bar">
              <div class="progress-parcent"><span>90</span>%</div>
            </div>
          </div>
        </div>
          </div>
          <div class="col-sm-6 mt-5">
            <div class="ht-progress-bar">
          <h6>Consulting</h6>
          <div class="progress" data-value="85">
            <div class="progress-bar">
              <div class="progress-parcent"><span>85</span>%</div>
            </div>
          </div>
        </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--about end-->


<!--portfolio start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="masonry row popup-gallery no-gutters">
          <div class="grid-sizer"></div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/01.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/01.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Creative Design</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-8 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/02.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/02.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>App</span>
                <h5><a href="portfolio-single.html">Mobile Ui</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/03.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/03.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Branding</span>
                <h5><a href="portfolio-single.html">Design Mockup</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/04.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/04.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>App</span>
                <h5><a href="portfolio-single.html">Mobile Screen</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-8 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/07.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/02.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Branding</span>
                <h5><a href="portfolio-single.html">Creative Cake</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/05.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/05.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Social Media</a></h5>
              </div>              
            </div>
          </div>
          <div class="masonry-brick col-lg-4 col-md-6">
            <div class="portfolio-item">
              <img class="img-fluid w-100" src="images/portfolio/06.jpg" alt="">
              <a class="popup-img" href="images/portfolio/large/06.jpg"> <i class="fas fa-plus-circle"></i>
              </a>
              <div class="portfolio-hover"> <span>Design</span>
                <h5><a href="portfolio-single.html">Development</a></h5>
              </div>              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--portfolio end-->


<!--team start-->

<section class="theme-bg pb-20" data-bg-img="images/bg/08.html">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-md-8">
        <div class="section-title mb-md-0">
          <h2 class="title mb-0">We Make It Simple To Take Your <span class="font-w-3 text-light">Business With Target Success.</span></h2>
        </div>
      </div>
      <div class="col-md-4 text-md-center">
        <div class="video-btn"> <a class="popup-youtube play-btn" href="https://www.youtube.com/watch?v=P_wKDMcr1Tg"><i class="fas fa-play-circle"></i></a> 
          </div>
      </div>
    </div>
  </div>
</section>

<!--team end-->

<!--service start-->

<section class="custom-mt-10 pt-0 text-center">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="white-bg py-5 px-3 p-md-5 box-shadow">
          <div class="row justify-content-center">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h2 class="title mb-0">We’re a Building Brands More <span>Quickly design agency</span></h2>
        </div>
      </div>
    </div>
          <div class="row">
      <div class="col-lg-4 col-md-6">
        <div class="featured-item style-3 shadow-none">
          <div class="featured-icon"> <i class="flaticon-histogram"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Marketing</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div> 
      <div class="col-lg-4 col-md-6 mt-5 mt-md-0">
        <div class="featured-item style-3 shadow-none active">
          <div class="featured-icon"> <i class="flaticon-challenges"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>Strategy</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 mt-5 mt-lg-0">
        <div class="featured-item style-3 shadow-none">
          <div class="featured-icon"> <i class="flaticon-support"></i>
            <span class="border-anim"></span>
          </div>
          <div class="featured-title">
            <h5>24/7 Support</h5>
          </div>
          <div class="featured-desc">
            <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
            <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
          </div>
        </div>
      </div>
    </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--service end-->

<section class="pt-0">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-md-0 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!--pricing table start-->

<section class="pos-r">
  <div class="dot-bg">
    <img class="img-fluid rotateme" src="images/pattern/04.png" alt="">
  </div>
  <div class="container">
    <div class="row align-items-end mb-5">
      <div class="col-lg-6 col-md-12 text-lg-left order-lg-1">
        <div class="section-title mb-lg-0 mb-2">
          <h2 class="title mb-0">Choose Your Best <span>Pricing plan</span></h2>
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        <p class="lead mb-0">Agencio discovering the source behind the ubiquitous filler text In seeing a sample of lorem ipsum, his interest was piqued by consectetur Agencio discovering</p>
      </div>      
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <div class="price-table theme-bg">
          <div class="price-header">
            <h4 class="price-title">Free</h4>
            <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum</p>
          </div>
          <div class="price-value">
            <h2>
              <span class="price-dollar">$</span>23
            </h2>
          </div>
          <div class="price-list">
            <ul class="list-unstyled">
              <li><i class="fas fa-check"></i> Free Domian</li>
              <li><i class="fas fa-check"></i> 500 MB Storage</li>
              <li><i class="fas fa-check"></i> 20 Database</li>
              <li><i class="fas fa-check"></i> Unlimited Site licenses</li>
              <li><i class="fas fa-check"></i> Professional Support</li>
            </ul>
          </div>
          
          <a class="btn btn-white btn-block mt-4" href="#"> <span>Get Started <i class="fas fa-plus-square"></i></span>
          </a>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 mt-5 mt-lg-0">
        <div class="price-table box-shadow">
          <div class="price-header">
            <h4 class="price-title">Standard</h4>
            <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum</p>
          </div>
          <div class="price-value">
            <h2>
              <span class="price-dollar">$</span>88
            </h2>
          </div>
          <div class="price-list">
            <ul class="list-unstyled">
              <li><i class="fas fa-check"></i> Free Domian</li>
              <li><i class="fas fa-check"></i> 500 MB Storage</li>
              <li><i class="fas fa-check"></i> 20 Database</li>
              <li><i class="fas fa-check"></i> Unlimited Site licenses</li>
              <li><i class="fas fa-check"></i> Professional Support</li>
            </ul>
          </div>          
          <a class="btn btn-theme btn-block mt-4" href="#"> <span>Get Started <i class="fas fa-plus-square"></i></span>
          </a>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 mt-5 mt-lg-0">
        <div class="price-table dark-bg">
          <div class="price-header">
            <h4 class="price-title">Premium</h4>
            <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum</p>
          </div>
          <div class="price-value">
            <h2>
              <span class="price-dollar">$</span>139
            </h2>
          </div>
          <div class="price-list">
            <ul class="list-unstyled">
              <li><i class="fas fa-check"></i> Free Domian</li>
              <li><i class="fas fa-check"></i> 500 MB Storage</li>
              <li><i class="fas fa-check"></i> 20 Database</li>
              <li><i class="fas fa-check"></i> Unlimited Site licenses</li>
              <li><i class="fas fa-check"></i> Professional Support</li>
            </ul>
          </div>          
          <a class="btn btn-white btn-block mt-4" href="#"> <span>Get Started <i class="fas fa-plus-square"></i></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<!--pricing table end-->

<section>
  <div class="container-fluid pr-lg-0">
    <div class="row align-items-center">
      <div class="col-lg-5 col-12 mr-auto">
        <div class="section-title">
          <div class="section-title">
            <h2 class="titl">We’re Partnering With <span>Your Favorite Brand</span></h2>
            <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-6">
            <img class="img-fluid" src="images/client/06.png" alt="">
          </div>
          <div class="col-sm-4 col-6">
            <img class="img-fluid" src="images/client/07.png" alt="">
          </div>
          <div class="col-sm-4 col-6 mt-5 mt-sm-0">
            <img class="img-fluid" src="images/client/08.png" alt="">
          </div>
          <div class="col-sm-4 col-6 mt-5">
            <img class="img-fluid" src="images/client/09.png" alt="">
          </div>
          <div class="col-sm-4 col-6 mt-5">
            <img class="img-fluid" src="images/client/10.png" alt="">
          </div>
          <div class="col-sm-4 col-6 mt-5">
            <img class="img-fluid" src="images/client/11.png" alt="">
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 mt-5 mt-lg-0">
        <div class="box-shadow p-3 p-md-5 pos-r">
          <div class="img-bg">
            <svg class="morph-shape" viewBox="0 0 500 500">
              <defs>
                <linearGradient id="main-gradien2" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="10%" style="stop-color:#0083ff;"></stop>
                  <stop offset="100%" style="stop-color:#00f2aa;"></stop>
                </linearGradient>
              </defs>
              <path id="object2" class="js-items-shape-path" fill="url(#main-gradien2)" d="M418.1 159.8 C460.9 222.9 497 321.5 452.4 383.4 417.2 432.4 371.2 405.6 271.3 420.3 137.19 440 90.45 500.6 42.16 442.8 -9.57 381 86.33 289.1 117.7 215.5 144.3 153.4 145.69 54.21 212.7 36.25 290.3 15.36 373.9 94.6 418.1 159.8 " data-original="M 418.1,159.8 C 460.9,222.9 497,321.5 452.4,383.4 417.2,432.4 371.2,405.6 271.3,420.3 137.2,440 90.45,500.6 42.16,442.8 -9.572,381 86.33,289.1 117.7,215.5 144.3,153.4 145.7,54.21 212.7,36.25 290.3,15.36 373.9,94.6 418.1,159.8 Z"></path>
            </svg>
          </div>
          <div class="owl-carousel" data-items="1" data-autoplay="true">
            <div class="item">
              <div class="testimonial style-3 shadow-none">
                <div class="testimonial-content">
                  <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                  </div>
                  <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                </div>
                <div class="d-sm-flex align-items-center">
                  <div class="testimonial-img">
                    <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
                  </div>
                  <div class="testimonial-caption">
                    <h5>Alvi Miller</h5>
                    <label>Founder of Agencio</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="testimonial style-3 shadow-none">
                <div class="testimonial-content">
                  <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                  </div>
                  <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                </div>
                <div class="d-sm-flex align-items-center">
                  <div class="testimonial-img">
                    <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
                  </div>
                  <div class="testimonial-caption">
                    <h5>Albert Jonson</h5>
                    <label>CEO of Agencio</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h2 class="title">Read Our <span>Latest News</span></h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">We Develop Digital Strategy</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 mt-5 mt-md-0">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">These guide Designing work</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 mt-5 mt-md-0">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">We're Nominated To Agency</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog end-->

</div>

<!--body content end--> 

        
    </div>
</template>
<script>
// @ is an alias to /src

export default {
  data: function () {
        return {
            hasBanner: false,
            name: "home",
        }
    }
};
</script>